import { CardType, PaymentRail } from '../../../payment.types';

export const CloverTokenizationResultType = {
    ECOMMERCE_BROWSER_TOKENIZATION:
        'clover_ecommerce_browser_tokenization_v1',
    STORED_CARD_METADATA: 'clover_stored_card_metadata_v1',
} as const;

export type CloverTokenizationResultType =
    (typeof CloverTokenizationResultType)[keyof typeof CloverTokenizationResultType];

export const CloverBrowserTokenizationSessionType =
    'clover_ecommerce_browser_tokenization_session_v1' as const;

export interface CloverEcommerceBrowserTokenizationSession {
    readonly browser_tokenization_session_type:
        typeof CloverBrowserTokenizationSessionType;
    readonly ecommerce_api_key: string;
    readonly ecommerce_tokenization_url: string;
    readonly terminal_tokenization_supported: true;
}

export interface CloverEcommerceTokenizedCard {
    readonly id?: string;
    readonly token?: string;
    readonly first6?: string;
    readonly last4?: string;
    readonly exp_month?: string;
    readonly exp_year?: string;
    readonly brand?: string;
    readonly name?: string;
    readonly country?: string;
}

export interface CloverEcommerceTokenizationSuccessResponse {
    readonly id?: string;
    readonly token: string;
    readonly card?: CloverEcommerceTokenizedCard;
    readonly created?: number;
}

export interface CloverCreditCardTokenizedCardMetadata {
    readonly payment_rail: typeof PaymentRail.CREDIT_CARD;
    readonly masked_pan: string;
    readonly card_type: typeof CardType.CREDIT;
    readonly card_brand: string;
    readonly cardholder_name: string;
    readonly expiry_date?: string;
    readonly first6?: string;
    readonly last4?: string;
}

export interface CloverDebitCardTokenizedCardMetadata {
    readonly payment_rail: typeof PaymentRail.DEBIT_CARD;
    readonly masked_pan: string;
    readonly card_type: typeof CardType.DEBIT;
    readonly card_brand: string;
    readonly cardholder_name: string;
    readonly expiry_date?: string;
    readonly first6?: string;
    readonly last4?: string;
}

export type CloverTokenizedCardMetadata =
    | CloverCreditCardTokenizedCardMetadata
    | CloverDebitCardTokenizedCardMetadata;

export interface CloverEcommerceBrowserTokenizationResult {
    readonly result_type: typeof CloverTokenizationResultType.ECOMMERCE_BROWSER_TOKENIZATION;
    readonly token_response: CloverEcommerceTokenizationSuccessResponse;
    readonly card_metadata?: CloverTokenizedCardMetadata;
}

export interface CloverStoredCardMetadataTokenizationResult {
    readonly result_type: typeof CloverTokenizationResultType.STORED_CARD_METADATA;
    readonly token: string;
    readonly card_metadata: CloverTokenizedCardMetadata;
}

export type CloverTokenizationResult =
    | CloverEcommerceBrowserTokenizationResult
    | CloverStoredCardMetadataTokenizationResult;
